import { render, staticRenderFns } from "./XDescriptions.vue?vue&type=template&id=53fee8a6&scoped=true"
import script from "./XDescriptions.vue?vue&type=script&lang=js"
export * from "./XDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fee8a6",
  null
  
)

export default component.exports